// extracted by mini-css-extract-plugin
module.exports = {"reviewPage":"members-day_reviewPage__h9y2N"};